import { defineComponent as B, computed as o, ref as b, watch as H, resolveComponent as w, resolveDirective as N, withDirectives as k, openBlock as r, createElementBlock as s, normalizeClass as $, createElementVNode as d, renderSlot as u, createCommentVNode as v, createVNode as m, Transition as O, withCtx as V, toDisplayString as R, vShow as I } from "vue";
import P from "../assets/utils/clickoutside.js";
import F from "../virtual-list/index.js";
import { _ as z } from "../_plugin-vue_export-helper-dad06003.js";
import { w as T } from "../util-b2b0dc25.js";
import "../assets/utils/dom.js";
import "../virtual-list-6f8b6d25.js";
import "../scrollbar2-f7c66394.js";
import "../assets/utils/scrollbar-width.js";
import "../scrollbar2/util.js";
const j = B({
  name: "rMySelect",
  components: { VirtualList: F },
  directives: { Clickoutside: P },
  model: {
    prop: "currentData",
    event: "update:currentData"
  },
  emits: {
    /**
     * 选项改变
     */
    selectChange: (e) => e,
    /**
     * 输入改变
     */
    input: (e) => e,
    /**
     * 输入聚焦
     */
    focus: () => null,
    /**
     * 输入失焦
     */
    blur: () => null,
    /**
     * 打开选择器
     */
    openSelect: () => null,
    /**
     * 关闭选择器
     */
    closeSelect: () => null
  },
  props: {
    /**
     * 输入框显示选中结果，当选中结果需要显示在别的地方，而不需要显示在输入框中时，可以设置成false
     */
    showValueInput: {
      type: Boolean,
      default: !0
    },
    /**
     * 搜索的placeholder
     */
    searchPlaceholder: {
      type: String,
      default: ""
    },
    /**
     * 可选数据列表
     */
    data: {
      type: Array,
      default: () => []
    },
    /**
     * 当前选中数据
     */
    currentData: {
      type: Object,
      default: () => null
    },
    /**
     * label 替换字段
     */
    labelReplace: {
      type: String,
      default: "label"
    },
    /**
     * value 替换字段
     */
    valueReplace: {
      type: String,
      default: "value"
    },
    /**
     * 是否开启过滤
     */
    filterable: {
      type: Boolean,
      default: !1
    },
    /**
     * 输入框模式
     * 默认为filter=筛选，未匹配筛选项时，会自动移除已输入内容
     * 可选为input=输入，未匹配筛选项时，也不会移除已输入内容（未匹配时，不显示emptyText）
     * 暂不考虑关闭过滤又同时支持输入框模式为input的场景（一般不会这样做交互）
     * 开启input模式后，还将支持clearable清空值
     */
    inputMode: {
      type: [String],
      default: "filter"
    },
    /**
     * 过滤参考的默认字段
     */
    filterKey: {
      type: String,
      default: "label"
    },
    /**
     * 过滤方法, 参数是(每项数据, 搜索内容)，返回false既不显示
     */
    filterCallback: Function,
    /**
     * 虚拟列表每项高度，启用虚拟列表的必要条件，否则降级为普通列表
     */
    virtualListItemHeight: {
      type: [Number, String],
      default: 50
    },
    /**
     * 虚拟列表可视区域高度，当虚拟列表组件或所在父组件初始高度不确定，比如：diaplay为none，导致无法准确获取容器高度，可以直接用此属性设置可视区域高度
     */
    virtualListWrapperHeight: {
      type: [Number, String],
      default: 266
    },
    /**
     * 虚拟列表class，用来设置虚拟列表最大可视区域的高度，最大高度默认为max-height:266px
     */
    virtualListWrapperClass: {
      type: String,
      default: ""
    },
    /**
     * 虚拟列表将依据此属性指定data中某个字段作为key，同列表key，用来帮助vue在diff中的原地复用，默认采用索引
     */
    virtualListkeyStr: {
      type: String,
      default: ""
    },
    /**
     * 空列表文案
     */
    emptyText: {
      type: String,
      default: "No Data"
    },
    /**
     * 禁用
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    inputSearchValue: {
      type: String,
      default: ""
    }
  },
  setup(e, l) {
    const C = o(() => {
      const a = ["r-my-select-list__virtual"];
      return e.virtualListWrapperClass && a.push(e.virtualListWrapperClass), a.join(" ");
    }), g = function() {
      l.emit("focus");
    }, S = function() {
      l.emit("blur");
    }, i = b(""), c = o(() => i.value ? e.data.filter((a) => {
      var D;
      return e.filterCallback ? e.filterCallback(a, i.value) : (D = a[e.filterKey]) == null ? void 0 : D.toLowerCase().includes(i.value.toLowerCase());
    }) : e.data || []), p = function(a) {
      i.value = a.target.value, l.emit("input", a.target.value);
    }, y = function() {
      (e.inputMode === "filter" || e.inputMode === "input" && e.currentData) && (i.value = "", l.emit("input", ""));
    }, t = b(!1);
    H(
      () => t.value,
      (a) => {
        a ? l.emit("openSelect") : l.emit("closeSelect");
      }
    );
    const h = function() {
      t.value = !1;
    }, M = function(a) {
      a.stopPropagation(), e.currentData && !t.value ? (l.emit("update:currentData", null), l.emit("clear", "filter"), L({})) : (i.value = "", l.emit("input", ""), l.emit("clear", "input"));
    }, f = b(null), L = function(a) {
      e.disabled || f.value === a.target && t.value && e.filterable || (t.value = !t.value, t.value ? f.value.focus() : f.value.blur());
    }, _ = function(a) {
      t.value = !1, l.emit("update:currentData", a), l.emit("selectChange", a);
    }, n = o(() => e.currentData ? e.currentData[e.labelReplace] : ""), W = o(() => e.currentData && t.value && e.showValueInput ? n.value : e.searchPlaceholder), A = o(() => {
      if (!e.showValueInput && !t.value)
        return "";
      if (e.inputMode === "input")
        return e.currentData ? t.value ? i.value : n.value : e.inputSearchValue ? (t.value, e.inputSearchValue) : (t.value, i.value);
      if (!e.currentData)
        return t.value ? i.value : "";
      if (e.currentData && !e.filterable)
        return n.value;
      if (e.currentData && e.filterable)
        return t.value ? i.value : n.value;
    });
    return {
      showList: t,
      searchValue: i,
      inputRef: f,
      filtedData: c,
      clickOutside: h,
      clickInside: L,
      clickClear: M,
      selectOption: _,
      virtualListWrapperClassResult: C,
      searchChange: p,
      currentDataLabel: n,
      onfocus: g,
      onblur: S,
      inputPlaceholder: W,
      inputValue: A,
      onAfterLeave: y
    };
  },
  beforeCreate() {
  }
}), E = {
  key: 0,
  class: "r-my-select-bar__prefix"
}, K = ["placeholder", "value", "readonly", "disabled"], U = {
  key: 2,
  class: "r-my-select-bar__suffix"
}, q = {
  key: 3,
  class: "r-my-select-bar__suffix"
}, G = { class: "r-my-select-list" }, J = {
  key: 0,
  class: "r-my-select-list__head"
}, Q = { class: "r-my-select-list__empty" }, X = { key: 1 }, Y = ["onClick"], Z = ["onClick"], x = {
  key: 1,
  class: "r-my-select-list__foot"
};
function ee(e, l, C, g, S, i) {
  const c = w("r-icon"), p = w("VirtualList"), y = N("clickoutside");
  return k((r(), s(
    "div",
    {
      class: $(["r-my-select", {
        "r-my-select__active": e.showList,
        "r-my-select__disabled": e.disabled
      }])
    },
    [
      d("div", {
        class: "r-my-select-bar",
        onClick: l[4] || (l[4] = (...t) => e.clickInside && e.clickInside(...t))
      }, [
        e.$slots.prefix ? (r(), s("div", E, [
          u(e.$slots, "prefix")
        ])) : v("v-if", !0),
        d("input", {
          ref: "inputRef",
          type: "text",
          class: "r-my-select-input",
          placeholder: e.inputPlaceholder,
          value: e.inputValue,
          onInput: l[0] || (l[0] = (...t) => e.searchChange && e.searchChange(...t)),
          readonly: !e.filterable,
          onFocus: l[1] || (l[1] = (...t) => e.onfocus && e.onfocus(...t)),
          onBlur: l[2] || (l[2] = (...t) => e.onblur && e.onblur(...t)),
          disabled: e.disabled
        }, null, 40, K),
        e.inputMode === "input" && (e.currentData || e.searchValue) ? (r(), s("div", {
          key: 1,
          class: "r-my-select-bar__clearable",
          onClick: l[3] || (l[3] = (...t) => e.clickClear && e.clickClear(...t))
        }, [
          m(c, {
            class: "r-my-select-bar__clearable-icon",
            name: "icon-close",
            size: 12
          })
        ])) : v("v-if", !0),
        e.$slots.suffix ? (r(), s("div", U, [
          u(e.$slots, "suffix")
        ])) : (r(), s("div", q, [
          m(c, {
            name: "icon-actions_select_down",
            class: "r-my-select-bar__icon"
          })
        ]))
      ]),
      m(O, {
        name: "el-zoom-in-top",
        onAfterLeave: e.onAfterLeave,
        persisted: ""
      }, {
        default: V(() => [
          k(d(
            "div",
            G,
            [
              e.$slots.listHead ? (r(), s("div", J, [
                u(e.$slots, "listHead")
              ])) : v("v-if", !0),
              k(d(
                "div",
                Q,
                [
                  e.$slots.empty ? u(e.$slots, "empty", { key: 0 }) : (r(), s(
                    "span",
                    X,
                    R(e.emptyText),
                    1
                    /* TEXT */
                  ))
                ],
                512
                /* NEED_PATCH */
              ), [
                [I, e.inputMode === "filter" && e.filtedData.length < 1]
              ]),
              m(p, {
                data: e.filtedData,
                "item-height": e.virtualListItemHeight,
                "wrapper-class": e.virtualListWrapperClassResult,
                "wrapper-height": e.virtualListWrapperHeight,
                "key-str": e.virtualListkeyStr
              }, {
                option: V(({ optionData: t }) => [
                  e.$slots.option ? (r(), s("div", {
                    key: 0,
                    onClick: (h) => e.selectOption(t)
                  }, [
                    u(e.$slots, "option", {
                      optionData: t,
                      isCurrent: e.currentData && t[e.valueReplace] === e.currentData[e.valueReplace]
                    })
                  ], 8, Y)) : (r(), s("div", {
                    key: 1,
                    onClick: (h) => e.selectOption(t),
                    class: $(["r-my-select__option", {
                      "r-my-select__option--isCurrent": e.currentData && t[e.valueReplace] === e.currentData[e.valueReplace]
                    }])
                  }, R(t[e.labelReplace]), 11, Z))
                ]),
                _: 3
                /* FORWARDED */
              }, 8, ["data", "item-height", "wrapper-class", "wrapper-height", "key-str"]),
              e.$slots.listFoot ? (r(), s("div", x, [
                u(e.$slots, "listFoot")
              ])) : v("v-if", !0)
            ],
            512
            /* NEED_PATCH */
          ), [
            [I, e.showList]
          ])
        ]),
        _: 3
        /* FORWARDED */
      }, 8, ["onAfterLeave"])
    ],
    2
    /* CLASS */
  )), [
    [y, e.clickOutside]
  ]);
}
const te = /* @__PURE__ */ z(j, [["render", ee], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/my-select/my-select.vue"]]), de = T(te);
export {
  de as default
};
